import { LoadingButton } from "@mui/lab";
import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { useApiMutation } from "src/hooks/useApiMutation";

interface IProps {
	handleClose?: Function;
}

const ApprovedSingleb2b = ({ handleClose }: IProps) => {
	const { register, handleSubmit, reset } = useForm();
	const { singleB2BId } = useParams();
	const [status, setStatus] = useState<string>("");
	const { mutate, isSuccess, isPending } = useApiMutation({
		endPoint: `/api/fair/admin/b2b/${singleB2BId}`,
		method: "PATCH",
		invalidateQueries: ["b2b_details"],
	});
	const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value) {
			setStatus(e.target.value);
		}
	};

	const onSubmit = async (status: { status: { status: string } }) => {
		mutate({ b2b_status: status?.status });
	};

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);
	return (
		<>
			<Box component='form' onSubmit={handleSubmit(onSubmit)}>
				<Grid container sx={{ mt: "15px" }}>
					<Grid item xs={12}>
						<FormControl required fullWidth>
							<InputLabel required id='demo-simple-select-label'>
								B2B Status
							</InputLabel>
							<Select
								{...register("status")}
								id='outlined-required'
								value={status}
								label='Invoice status'
								required
								onChange={handleStatusChange}
							>
								<MenuItem value='approved'>approved</MenuItem>
								<MenuItem value='pending'>pending</MenuItem>
								<MenuItem value='rejected'>rejected</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				{!isPending ? (
					<Button
						type='submit'
						fullWidth
						variant='contained'
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Update
					</Button>
				) : (
					<LoadingButton
						loading
						loadingIndicator='Updating...'
						fullWidth
						variant='outlined'
						disabled
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						<span>Updating...</span>
					</LoadingButton>
				)}
			</Box>
		</>
	);
};

export default ApprovedSingleb2b;
